import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from '@xingternal/button';

type FollowProps = {
  isFollowing?: boolean,
  toggleFollow: () => void,
  loading?: boolean,
  className?: string,
  smallOnWide?: boolean,
};

const Follow = ({
  isFollowing,
  toggleFollow,
  loading,
  className,
  smallOnWide,
} : FollowProps) => {
  const buttonText = isFollowing ? 'EP_FOLLOWING' : 'EP_FOLLOW';

  return (
    <Button
      data-testid={'followButton'}
      variant={isFollowing ? 'tertiary' : 'primary'}
      sizeWide={smallOnWide ? 'small' : undefined}
      size={'medium'}
      className={className}
      disabled={loading}
      onClick={(e) => {
        e.preventDefault();
        if (!loading) {
          toggleFollow();
        }
      }}
    >
      <FormattedMessage id={buttonText} defaultMessage={buttonText} />
    </Button>
  );
};

export default Follow;
